import {toAbsoluteUrl} from '../../../../_metronic/helpers'

function CreateError() {
  return <h1 className='fw-bolder text-dark mb-3'>Что-то пошло не так.</h1>
}

export {CreateError}
